import React from 'react';

const SmartLegalToolsIcon = () => {
  return (
    <>
      <svg
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.42676 15.7342C8.72122 15.8606 9.02801 15.9208 9.33018 15.9208C9.54755 15.9208 9.76184 15.8884 9.96689 15.8298C10.8842 13.9567 12.4197 11.342 14.6767 9.08502C16.8905 6.87119 19.4142 5.36035 21.329 4.41685C21.4477 3.94665 21.4199 3.43635 21.218 2.95381C20.72 1.77598 19.3603 1.22406 18.1886 1.72356C18.0421 1.78523 14.5734 3.26985 11.6612 6.1836C8.75514 9.08965 7.26434 12.5615 7.20268 12.7079C6.70626 13.8827 7.25355 15.2347 8.42676 15.7342Z"
          fill="white"
        />
        <path
          d="M30.3289 13.1905C29.427 12.1576 28.3695 11.0106 27.1793 9.81889C25.9891 8.62718 24.8375 7.56806 23.8077 6.66772C22.2814 7.3291 19.3014 8.82143 16.8548 11.265C14.3773 13.7424 12.8803 16.7564 12.2082 18.3335C12.1974 18.3597 12.185 18.3844 12.1727 18.4091C12.6306 18.9348 13.1285 19.4913 13.6635 20.0648L2.21663 31.5117C1.31321 32.4136 1.31321 33.8797 2.21663 34.7816C2.66833 35.2333 3.26033 35.4583 3.85233 35.4583C4.44433 35.4583 5.03633 35.2333 5.48804 34.7816L16.9349 23.3347C17.51 23.8696 18.0634 24.3676 18.5891 24.8255C18.6138 24.8131 18.64 24.8008 18.6662 24.79C20.2387 24.1194 23.2496 22.6255 25.7332 20.1419C28.1752 17.6983 29.6753 14.6983 30.3289 13.1905Z"
          fill="white"
        />
        <path
          d="M34.049 15.7882C33.5664 15.5816 33.05 15.5539 32.5752 15.6757C31.6332 17.5858 30.1193 20.1141 27.9116 22.3218C25.6484 24.5834 23.0353 26.1189 21.1637 27.0347C21.0234 27.5249 21.0435 28.063 21.2562 28.5686C21.6293 29.452 22.4865 29.9823 23.3868 29.9823C23.6874 29.9823 23.9927 29.9238 24.2856 29.7989C24.4321 29.7372 27.9008 28.2526 30.813 25.3388C33.7191 22.4328 35.2099 18.961 35.2715 18.8145C35.7679 17.6398 35.2222 16.2877 34.049 15.7882Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default SmartLegalToolsIcon;
